<template>
  <RouterView id="app" />
</template>

<script>
export default {

}
</script>